/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Scope_Applies_ToInputs */

const es_privacy_policy_scope_applies_to = /** @type {(inputs: Privacy_Policy_Scope_Applies_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta Politica de Privacidad se aplica a:`)
};

const en_privacy_policy_scope_applies_to = /** @type {(inputs: Privacy_Policy_Scope_Applies_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Privacy Policy applies to:`)
};

/**
* | output |
* | --- |
* | "This Privacy Policy applies to:" |
*
* @param {Privacy_Policy_Scope_Applies_ToInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_scope_applies_to = /** @type {((inputs?: Privacy_Policy_Scope_Applies_ToInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Scope_Applies_ToInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_scope_applies_to(inputs)
	return en_privacy_policy_scope_applies_to(inputs)
});
export { privacy_policy_scope_applies_to as "privacy_policy.scope.applies_to" }